import styled from "styled-components";

export const Expired = styled.div`
  font-size: 36px;
  color: red;
  height: 230px;
  text-align: center;
  margin-top: 50px;
`;
